import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/repasse';

export default {

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getVigentes(){
    return Http.get(`${path}/vigentes`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getList(filtros) {
    return Http.post(`${path}/list`, filtros);
  },

}
